import { cn } from "../../utils/cn";

export function TwitterIcon({ className }: { className?: string }) {
  return (
    <div className={cn("w-full h-full", className)}>
      <svg width="100%" height="100%" viewBox="0 0 1200 1226.37">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <path
            d="M714.163,519.284 L1160.89,0 L1055.03,0 L667.137,450.887 L357.328,0 L0,0 L468.492,681.821 L0,1226.37 L105.866,1226.37 L515.491,750.218 L842.672,1226.37 L1200,1226.37 L714.137,519.284 L714.163,519.284 Z M569.165,687.828 L521.697,619.934 L144.011,79.6944 L306.615,79.6944 L611.412,515.685 L658.88,583.579 L1055.08,1150.3 L892.476,1150.3 L569.165,687.854 L569.165,687.828 Z"
            fill="currentColor"
            fillRule="nonzero"></path>
        </g>
      </svg>
    </div>
  );
}
